import { Skeleton } from '@ibsys/kit';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useKmEntity } from '@/entities/ontology';
import { useHasPermission } from '@/entities/profile';
import { KmEntityCardView } from './KmEntityCardView';

type Props = {
  /** Идентификатор сущности из адреса страницы */
  id?: string;
};

/**
 * Правая панель: карточка сущности модели знаний. Значения атрибутов и условие
 * применимости изменяются прямо в ней; без права на изменение карточка только показывает.
 */
export const KmEntityCard: FC<Props> = ({ id }) => {
  const { t } = useTranslation(['kmEntities', 'common']);
  const entityId = id ? Number(id) : undefined;

  const { data: entity, isLoading } = useKmEntity(entityId);
  const canEdit = useHasPermission('ADMIN_KM_ENTITY_TYPE');

  if (!entityId) {
    return (
      <div className="flex items-center justify-center h-full text-muted-foreground">
        {t('kmEntities:selectEntity')}
      </div>
    );
  }

  if (isLoading) {
    return <Skeleton className="h-full" />;
  }

  if (!entity) {
    return (
      <div className="flex items-center justify-center h-full text-muted-foreground">
        {t('kmEntities:entityNotFound')}
      </div>
    );
  }

  return <KmEntityCardView entity={entity} canEdit={canEdit} />;
};
